import { WallpaperConfig } from "../../config/wallpapers";

import useEnv from "./use-env";
import { useSettings } from "./use-settings";
import * as lib from "./use-wallpaper-config.lib";

export const useWallpaperConfig = (): WallpaperConfig => {
  const env = useEnv();
  const settings = useSettings();

  return lib.getWallpaperConfig(settings.initialized.customization.wallpaper, env.customerGroupConfig);
};
